import api from './api';

const stampyt = {
  // Véhicules
  listVehicules: (params) => api.get('/stampyt', { params }),
  createVehicule: (data) => api.post('/stampyt', data),
  getVehicule: (id) => api.get(`/stampyt/${id}`),
  updateStatut: (id, statut) => api.put(`/stampyt/${id}/statut`, { statut }),
  deleteVehicule: (id) => api.delete(`/stampyt/${id}`),

  // Photos — upload en deux temps (presign → upload S3 → confirm)
  presignPhoto: (vehiculeId, data) => api.post(`/stampyt-photos/${vehiculeId}/presign`, data),
  confirmPhoto: (vehiculeId, data) => api.post(`/stampyt-photos/${vehiculeId}/confirm`, data),
  processPhotos: (vehiculeId) => api.post(`/stampyt-photos/${vehiculeId}/process`),
  processOnePhoto: (vehiculeId, photoId) => api.post(`/stampyt-photos/${vehiculeId}/${photoId}/process`),
  getStatus: (vehiculeId) => api.get(`/stampyt-photos/${vehiculeId}/status`),
  getUrls: (vehiculeId) => api.get(`/stampyt-photos/${vehiculeId}/urls`),
  deletePhoto: (vehiculeId, photoId) => api.delete(`/stampyt-photos/${vehiculeId}/${photoId}`),
  downloadZip: (vehiculeId) => api.get(`/stampyt-photos/${vehiculeId}/download`, { responseType: 'blob' }),

  /**
   * Upload complet d'une photo vers S3.
   * 1. Presign
   * 2. PUT direct sur S3
   * 3. Confirm (metadata en DB)
   * Retourne la photo enregistrée.
   */
  async uploadPhoto(vehiculeId, file, typePriseVue, ordre) {
    // 1. Presign
    const presignRes = await this.presignPhoto(vehiculeId, {
      typePriseVue,
      ordre,
      filename: file.name,
      contentType: file.type || 'image/jpeg',
    });
    const { uploadUrl, key } = presignRes.data;

    // 2. Upload direct S3
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type || 'image/jpeg' },
    });

    // 3. Confirm
    const confirmRes = await this.confirmPhoto(vehiculeId, {
      key,
      typePriseVue,
      ordre,
      filename: file.name,
      contentType: file.type || 'image/jpeg',
    });

    return confirmRes.data.photo;
  },

  // Fonds (arrière-plans)
  listFonds: () => api.get('/stampyt-fonds'),
  presignFond: (data) => api.post('/stampyt-fonds/presign', data),
  confirmFond: (data) => api.post('/stampyt-fonds/confirm', data),
  deleteFond: (fondId) => api.delete(`/stampyt-fonds/${fondId}`),
  applyBackground: (photoId, fondId) => api.post('/stampyt-fonds/apply', { photoId, fondId }),

  async uploadFond(file, nom, concessionId) {
    const presignRes = await this.presignFond({
      nom,
      filename: file.name,
      contentType: file.type || 'image/jpeg',
      concession_id: concessionId,
    });
    const { uploadUrl, key, concession_id } = presignRes.data;

    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type || 'image/jpeg' },
    });

    const confirmRes = await this.confirmFond({ nom, key, concession_id });
    return confirmRes.data.fond;
  },
};

export default stampyt;
